<template>
  <!-- <div class="ism-page-wrapper"> -->
    <!-- Card Container -->
    <div class="ism-detail-card">
      
      <!-- Card Header (Integrated) -->
      <div class="ism-detail-card-header">
        <div class="ism-header-top">
          <div class="ism-header-left">
            <div class="ism-soc-logo-wrap">
              <PremiumAvatar
                :image="member && member.profile_url ? API_BASE_URL + '/uploads/' + member.profile_url : null"
                :name="member.name"
                :size="84"
              />
            </div>
            
            <div class="ism-soc-header-info">
              <div style="display:flex;align-items:center;gap:12px;margin-bottom:6px;flex-wrap:wrap;">
                <span class="ism-soc-name">{{ member.name || '—' }}</span>
                <span class="ism-badge ism-badge-blue">
                  {{ memberType(member.member_type) }}
                </span>
                <span v-if="member.is_security_guard" class="ism-badge ism-badge-orange">
                  Security Guard
                </span>
              </div>
              <div class="ism-header-meta">
                <div class="ism-meta-item">
                  <v-icon size="14" style="opacity: 0.7;">mdi-phone-outline</v-icon>
                  {{ member.country_code }} {{ member.mobile_no }}
                </div>
                <span class="ism-meta-sep">|</span>
                <div class="ism-meta-item">
                  <v-icon size="14" style="opacity: 0.7;">mdi-email-outline</v-icon>
                  {{ member.email || 'N/A' }}
                </div>
              </div>
            </div>
          </div>

          <button class="ism-btn-cancel ism-back-btn" @click="$router.go(-1)">
            <v-icon size="15" color="var(--accent)">mdi-arrow-left</v-icon>
            Back
          </button>
        </div>

        <!-- Section Title -->
        <div class="ism-tab-bar">
          <div class="ism-tab-btn active">Profile Overview</div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="ism-tabs-content-scroll">
        <div class="ism-tab-body">
          <div class="ism-detail-grid">
            
            <!-- Column 1: Contact Info -->
            <div class="ism-detail-panel">
              <div class="ism-panel-title">
                <v-icon size="16" color="var(--accent)" class="mr-2">mdi-card-account-details-outline</v-icon>
                Contact Information
              </div>
              <div class="ism-info-grid">
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(59,130,246,0.1);"><v-icon size="18" color="#3b82f6">mdi-account-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Full Name</span>
                    <span class="ism-info-value">{{ member.name }}</span>
                  </div>
                </div>
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(242,101,34,0.1);"><v-icon size="18" color="#F26522">mdi-phone-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Mobile Number</span>
                    <span class="ism-info-value">{{ member.country_code }} {{ member.mobile_no }}</span>
                  </div>
                </div>
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(239,68,68,0.1);"><v-icon size="18" color="#ef4444">mdi-email-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Email Address</span>
                    <span class="ism-info-value" style="word-break:break-all;">{{ member.email || '—' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ism-detail-vdivider"></div>

            <!-- Column 2: Residence Details -->
            <div class="ism-detail-panel">
              <div class="ism-panel-title">
                <v-icon size="16" color="var(--accent)" class="mr-2">mdi-home-city-outline</v-icon>
                Property Details
              </div>
              <div class="ism-info-grid">
                <div class="ism-info-item">
                  <div class="ism-info-icon" style="background:rgba(139,92,246,0.1);"><v-icon size="18" color="#8b5cf6">mdi-office-building-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Wing / Flat</span>
                    <span class="ism-info-value">{{ member.flat ? member.flat.name : '—' }}</span>
                  </div>
                </div>
                <div class="ism-info-item">
                  <div class="ism-info-icon" style="background:rgba(245,158,11,0.1);"><v-icon size="18" color="#f59e0b">mdi-home-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">House No</span>
                    <span class="ism-info-value">{{ member.house_number }}</span>
                  </div>
                </div>
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(100,116,139,0.1);"><v-icon size="18" color="#64748b">mdi-briefcase-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Occupation</span>
                    <span class="ism-info-value">{{ member.business || '—' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ism-detail-vdivider"></div>

            <!-- Column 3: Activity & Status -->
            <div class="ism-detail-panel">
              <div class="ism-panel-title">
                <v-icon size="16" color="var(--accent)" class="mr-2">mdi-chart-timeline-variant-shimmer</v-icon>
                Activity & Status
              </div>
              <div class="ism-info-grid">
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(100,116,139,0.1);"><v-icon size="18" color="#64748b">mdi-clock-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Last Active</span>
                    <span class="ism-info-value">{{ formatDate(member.last_active_time) }}</span>
                  </div>
                </div>
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(16,185,129,0.1);"><v-icon size="18" color="#10b981">mdi-check-circle-outline</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Member Status</span>
                    <div style="display:flex; align-items:center; gap:8px;">
                      <div class="status-dot" :class="member.status == 1 ? 'active' : 'inactive'"></div>
                      <span class="ism-info-value" style="margin-top:0;">{{ member.status == 1 ? 'Active' : 'Inactive' }}</span>
                    </div>
                  </div>
                </div>
                <div class="ism-info-item ism-info-item--full">
                  <div class="ism-info-icon" style="background:rgba(242,101,34,0.1);"><v-icon size="18" color="#F26522">mdi-history</v-icon></div>
                  <div class="ism-info-content">
                    <span class="ism-info-label">Joined On</span>
                    <span class="ism-info-value">{{ formatDate(member.created_at) }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
import PremiumAvatar from "../../common/PremiumAvatar.vue";

export default {
  name: 'MemberDetailView',
  components: { PremiumAvatar },
  data() {
    return {
      loading: false,
      society_id: "",
      member_id: "",
      member: {
        name: '',
        flat: { name: '' }
      },
      memberTypes: [
        { id: "1", name: "Owner" },
        { id: "2", name: "Tenant" },
      ],
      API_BASE_URL: process.env.VUE_APP_API_URL || 'https://api-staging.ismartsociety.com/api',
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    
    getMemberDetails() {
      this.loading = true;
      this.$axios
        .get(`superadmin/society/${this.society_id}/members/${this.member_id}`)
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.member = response.data.member;
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "3000",
              message: response.data.message,
            });
          }
        })
        .catch(() => { this.loading = false; });
    },

    memberType(memberType) {
      let type = this.memberTypes.find((t) => t.id == memberType);
      return type ? type.name : "N/A";
    },

    formatDate(date) {
      if (!date) return '—';
      return moment(date).format('DD MMM, YYYY hh:mm A');
    }
  },
  mounted() {
    this.society_id = this.$route.params.id;
    this.member_id = this.$route.params.member_id;
    this.getMemberDetails();
  },
};
</script>

<style scoped>
.ism-page-wrapper {
  max-width: 100%; padding: 24px;
  background: var(--bg-secondary);
  min-height: calc(100vh - 64px);
}

/* ── Card Container ───────────────────────── */
.ism-detail-card {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Card Header ──────────────────────────── */
.ism-detail-card-header {
  padding: 0;
  border-bottom: 1px solid var(--border-color);
  background: var(--card-bg);
}

.ism-header-top {
  display: flex; align-items: center; gap: 24px;
  padding: 18px 24px;
  background: linear-gradient(180deg, var(--bg-primary) 0%, var(--card-bg) 100%);
  flex-wrap: wrap;
}

.ism-header-left {
  display: flex; align-items: center; gap: 24px; flex: 1; min-width: 0;
}

/* Hero Avatar */
.ism-soc-logo-wrap {
  width: 84px; height: 84px;
  border-radius: 50%;
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
  overflow: hidden;
  background: var(--bg-primary);
  flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  border: 4px solid var(--card-bg);
}
.ism-soc-logo-img {
  width: 100%; height: 100%;
  object-fit: cover;
  display: block;
}
.ism-soc-logo-fallback {
  width: 100%; height: 100%;
  background: linear-gradient(135deg, var(--accent), var(--accent-hover));
  display: flex; align-items: center; justify-content: center;
  font-size: 36px; font-weight: 800; color: #fff;
}

/* Info */
.ism-soc-header-info {
  display: flex; flex-direction: column; flex: 1; min-width: 0;
}
.ism-soc-name {
  font-size: 24px; font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.02em; line-height: 1.2;
  margin: 0;
}

/* Meta Data */
.ism-header-meta {
  font-size: 13.5px; color: var(--text-secondary);
  font-weight: 500; display: flex; align-items: center;
  gap: 12px; flex-wrap: wrap; margin-top: 8px;
}
.ism-meta-item {
  display: flex; align-items: center; gap: 6px; white-space: nowrap;
}
.ism-meta-sep {
  opacity: 0.3; font-weight: 300; font-size: 14px;
}

.ism-back-btn {
  margin-left: auto;
  align-self: center;
}

/* ── Section Title ─────────────────────────── */
.ism-tab-bar {
  display: flex; padding: 0 28px;
  border-bottom: 1px solid var(--border-color);
}
.ism-tab-btn {
  padding: 14px 24px; font-size: 13.5px;
  font-weight: 600; color: var(--text-secondary);
  border-bottom: 3px solid transparent;
  font-family: "Inter", sans-serif;
}
.ism-tab-btn.active {
  color: var(--accent); border-bottom-color: var(--accent);
}

/* ── Content Area ─────────────────────────── */
.ism-tabs-content-scroll {
  background: transparent;
  display: flex; flex-direction: column;
}
.ism-tab-body { padding: 32px 28px; }

.ism-detail-grid {
  display: flex; gap: 32px;
  background: transparent;
}

.ism-detail-panel { flex: 1; min-width: 0; }
.ism-detail-vdivider {
  width: 1px; background: linear-gradient(to bottom, transparent, var(--border-color2), transparent);
  align-self: stretch; opacity: 0.6;
}

.ism-panel-title {
  font-size: 12.5px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: var(--text-secondary);
  margin-bottom: 24px;
  display: flex; align-items: center;
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 10px;
}

/* ── Info Grid ──────────────────────────────── */
.ism-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.ism-info-item {
  display: flex; align-items: flex-start; gap: 12px;
  padding: 14px 16px; background: var(--bg-primary);
  border: 1px solid var(--border-color); border-radius: 12px;
  transition: all 0.2s;
}
.ism-info-item:hover {
  transform: translateY(-2px); box-shadow: var(--shadow-sm);
  border-color: rgba(242,101,34,0.15); background: var(--card-bg);
}
.ism-info-item--full { grid-column: 1 / -1; }

.ism-info-icon {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ism-info-content { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.ism-info-label {
  font-size: 10.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--text-secondary);
}
.ism-info-value {
  font-size: 14px; font-weight: 600; color: var(--text-primary); line-height: 1.4;
}

.status-dot {
  width: 8px; height: 8px; border-radius: 50%;
}
.status-dot.active { background: #10b981; box-shadow: 0 0 8px rgba(16,185,129,0.4); }
.status-dot.inactive { background: #ef4444; }

@media (max-width: 1200px) {
  .ism-detail-grid { flex-direction: column; }
  .ism-detail-vdivider { display: none; }
}
@media (max-width: 900px) {
  .ism-header-top { padding: 20px; flex-direction: column; align-items: flex-start; }
  .ism-header-left { width: 100%; }
  .ism-back-btn { align-self: stretch; justify-content: center; }
}
</style>